import { useState } from "react";

import "./SeempPage.scss";

import SeempBody from "../../components/Seemp/SeempBody";

const SeempPage = () => {
	const [activeTabName, setActiveTabName] = useState("all");

	return (
		<div className="seemp-page-wrapper">
			<div className="seemp-body">
				<SeempBody activeTab={activeTabName} />
			</div>
		</div>
	);
};

export default SeempPage;
